export const iconFontAwesomeUsersPeopleHeadSideVirus = (
	<i className="fa-solid fa-head-side-virus"></i>
);
